/**
 * A one-shot "play it" for the next walkthrough a strategy opens.
 *
 * Raised by BotDetail when the Auto-verify loop accepts a walkthrough and opens the mode for the
 * user; taken by the walkthrough session as it starts. The session would otherwise open that run
 * paused, because it attaches to the run the chat just built rather than building one itself —
 * and a run the user did not see being prepared normally opens on their own terms. This one they
 * did: the verdict is the cue, and the replay is the answer to it.
 *
 * A module-level map rather than a prop or a URL flag. The chat and the Workbench live in
 * separate subtrees of BotDetail, and the intent must not outlive the moment: in the URL a reload
 * would replay it, and as a prop it would keep firing for every rebuild while the mode stays on.
 * `take` consumes it, and a request nobody took soon expires — the mode can bounce straight back
 * to Canvas (no drawings, say), and a later, unrelated entry must not start playing on its own.
 */

/** Long enough for the Workbench to mount and restore on the way in; short enough to be the same moment. */
const TTL_MS = 30_000

const pending = new Map<string, number>()

export const walkthroughAutoplay = {
  request(bid: string): void {
    pending.set(bid, Date.now())
  },

  /** True once per request, while it is fresh. */
  take(bid: string): boolean {
    const at = pending.get(bid)
    pending.delete(bid)
    return at != null && Date.now() - at <= TTL_MS
  },
}
